import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  static values = {
    entityName: String
  }
  
  static outlets = ["confirmation-dialog"]


  connect() {
    // No event listeners needed in this controller now
  }
  
  disconnect() {
    // No event listeners to remove
  }
  
  openConfirmation(event) {
    if (event) {
      event.preventDefault()
      
      // If data is passed via the triggering element, capture it
      const element = event.currentTarget
      
      if (element.dataset.recordDeletionEntityNameValue) {
        this.entityNameValue = element.dataset.recordDeletionEntityNameValue
      }
    }
    
    // Use the outlet to access the confirmation dialog controller
    if (this.hasConfirmationDialogOutlet) {
      // Configure the dialog
      this.confirmationDialogOutlet.configure({
        title: 'Confirm Deletion',
        message: `Remove <span class="font-medium">${this.entityNameValue || 'this item'}</span>?`,
        buttonText: 'Remove',
        actionType: 'delete',
        callerController: this
      })
      
      // Open the dialog
      this.confirmationDialogOutlet.open()
    }
  }
  
  // Method that will be called by the confirmation dialog controller
  confirmAction() {
    // Submit the form if it exists
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
